import ADCIntlService from '@adc/i18n/services/adc-intl';

export default class UnattendedShowingIntlService extends ADCIntlService {}
